import { render, staticRenderFns } from "./SharedEvents.vue?vue&type=template&id=2bfba439"
import script from "./SharedEvents.vue?vue&type=script&lang=js"
export * from "./SharedEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports